
import { useState } from 'react';

export type ViewMode = 'list' | 'table';

export function useViewModeToggle(defaultMode: ViewMode = 'list') {
  const [viewMode, setViewMode] = useState<ViewMode>(defaultMode);

  const toggleViewMode = () => {
    setViewMode(prev => prev === 'list' ? 'table' : 'list');
  };

  return {
    viewMode,
    toggleViewMode
  };
}
